import {
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation,
} from '@angular/core';
import {
    IJobTrigger,
    JobTriggerType,
} from '@models';
import {
    GRID_SERVICE,
    GridPageState,
    ODataGridComponent,
} from '@pages/generics/grid';
import { JobTriggerService } from '@services';

@Component({
    selector: 'ui-job-triggers-grid',
    templateUrl: './job-triggers.grid.html',
    styleUrls: ['./job-triggers.grid.scss'],
    providers: [{
        provide: GRID_SERVICE,
        useClass: JobTriggerService,
    }],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JobTriggersGridComponent
    extends ODataGridComponent<IJobTrigger, number> {

    public JobTriggerType = JobTriggerType;
    public expandedRow?: IJobTrigger;

    @Input()
    public set jobId(value: number) {
        this._state$.next(GridPageState.pending);

        this._filters$.next([{
            method: 'eq',
            property: 'jobId',
            value,
        }]);

        this._state$.next(GridPageState.ready);
    }

    public toggleRow(entity: IJobTrigger) {
        this.expandedRow = this.expandedRow === entity
            ? undefined
            : entity;
    }

}
